import { useRolodexSignedURLs } from 'features/rolodex'
import { CalibrationPageData } from 'pages/reporting/reports/raut/rautReportData'
import { useMemo } from 'react'

interface PDFImageData {
  imagePath: string
  imageCaption?: string
  signedUrl?: string
}

export const useCalibrationImage = (
  metadataEntryId: string,
  calibrationData?: CalibrationPageData
) => {
  // Extract the calibration image path if it exists
  const calibrationImagePath = calibrationData?.calibrationImage?.imagePath

  // Get signed URL for the calibration image
  const { results: signedUrlResults } = useRolodexSignedURLs(
    calibrationImagePath
      ? [
          {
            entry_id: metadataEntryId,
            path: calibrationImagePath,
          },
        ]
      : []
  )

  // Process the calibration image data
  return useMemo((): PDFImageData | undefined => {
    if (!calibrationData?.calibrationImage?.imagePath) {
      return undefined
    }

    const signedUrl = signedUrlResults.find(
      (result) => result.path === calibrationData.calibrationImage?.imagePath
    )?.signed_url

    if (!signedUrl) {
      return undefined
    }

    return {
      imagePath: calibrationData.calibrationImage.imagePath,
      imageCaption: calibrationData.calibrationImage.imageCaption,
      signedUrl,
    }
  }, [calibrationData, signedUrlResults])
}
